var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStateMinus = function SvgStateMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#State=Minus_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 20,
    width: 18,
    height: 18,
    rx: 9,
    transform: "rotate(-90 2 20)",
    fill: "#230C00"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 10,
    height: 10,
    rx: 5,
    transform: "rotate(-90 6 16)",
    fill: "#230C00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.11 10.133 8.802 7.826l-.973.973 2.308 2.308-2.252 2.25.86.86 2.252-2.25 2.308 2.307.973-.973-2.308-2.308 2.251-2.251-.86-.86-2.251 2.252Z",
    fill: "#FFFEFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "State=Minus_svg__a",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_160_1245"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_160_1245",
    result: "shape"
  })))));
};
export default SvgStateMinus;